import React from "react";
import { Box, Grid,  } from "@mui/material";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";
import ProfileDetails from "./ProfileComponents/ProfileDetails";
import Settings from "./ProfileComponents/Settings";
import Balances from "./ProfileComponents/Balances";
import PaymentInstruments from "./ProfileComponents/PaymentInstruments";

function AccountsAndProfileModal({ open, handleCloseModal, role, pictureData, setPictureData }) {
    return (
      <BaseDrawer open={open} handleClose={handleCloseModal} height="90vh">
        <Box sx={{ p: 3, overflowY: "auto", maxHeight: "100%" }}>
  
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <ProfileDetails role={role} pictureData={pictureData} setPictureData={setPictureData} />
              <PaymentInstruments />
            </Grid>
  
            {/* Right Side (Settings and Balance) */}
            <Grid item xs={12} md={6}>
                <Settings />
                <Balances />
            </Grid>
          </Grid>
        </Box>
      </BaseDrawer>
    );
  }

export default AccountsAndProfileModal;